module.exports = __webpack_public_path__ + "img/energy_1.74b2416a.png";